import { Link } from "react-router-dom";
import SocialIcon from "@/components/SocialIcon";
import { BRAND, PRODUCTS, SOCIALS } from "@/data/content";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-primary text-primary-foreground mt-0">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-16 md:py-24">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <p className="font-heading text-3xl font-bold">JINSU</p>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-primary-foreground/80">
              {BRAND.tagline} Suihkusuodattimet, jotka puhdistavat veden juuri ennen käyttöä –
              siellä missä sillä on eniten merkitystä.
            </p>
            <div className="mt-6 flex items-center gap-3" data-testid="footer-socials">
              {SOCIALS.map((s) => (
                <a
                  key={s.name}
                  href={s.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.name}
                  data-testid={`social-${s.name.toLowerCase()}`}
                  className="flex h-10 w-10 items-center justify-center rounded-full bg-white/10 text-primary-foreground transition-colors duration-200 hover:bg-white/20"
                >
                  <SocialIcon name={s.name} size={18} strokeWidth={1.8} />
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-2">
            <p className="eyebrow text-primary-foreground/60">Kauppa</p>
            <ul className="mt-5 space-y-3 text-sm">
              {PRODUCTS.map((p) => (
                <li key={p.slug}>
                  <Link
                    to={`/tuote/${p.slug}/`}
                    className="text-primary-foreground/80 transition-colors hover:text-white"
                    data-testid={`footer-product-${p.slug}`}
                  >
                    {p.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="eyebrow text-primary-foreground/60">Yritys</p>
            <ul className="mt-5 space-y-3 text-sm">
              <li><Link to="/tietoja-meista/" className="text-primary-foreground/80 transition-colors hover:text-white" data-testid="footer-about">Tietoja meistä</Link></li>
              <li><Link to="/yhteystiedot/" className="text-primary-foreground/80 transition-colors hover:text-white" data-testid="footer-contact">Yhteystiedot</Link></li>
              <li><Link to="/ukk/" className="text-primary-foreground/80 transition-colors hover:text-white" data-testid="footer-faq">UKK</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="eyebrow text-primary-foreground/60">Asiakaspalvelu</p>
            <ul className="mt-5 space-y-3 text-sm">
              <li><Link to="/maksu-ja-toimitus/" className="text-primary-foreground/80 transition-colors hover:text-white" data-testid="footer-shipping">Maksu ja toimitus</Link></li>
              <li><Link to="/peruutusoikeus/" className="text-primary-foreground/80 transition-colors hover:text-white" data-testid="footer-returns">Peruutusoikeus</Link></li>
              <li><Link to="/kayttoehdot/" className="text-primary-foreground/80 transition-colors hover:text-white" data-testid="footer-terms">Käyttöehdot</Link></li>
              <li><Link to="/tietosuojakaytanto/" className="text-primary-foreground/80 transition-colors hover:text-white" data-testid="footer-privacy">Tietosuojakäytäntö</Link></li>
              <li><Link to="/evastekaytanto/" className="text-primary-foreground/80 transition-colors hover:text-white" data-testid="footer-cookies">Evästekäytäntö</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-3 border-t border-white/15 pt-8 text-xs text-primary-foreground/60 md:flex-row md:items-center md:justify-between">
          <p data-testid="footer-company">
            {BRAND.company} · Y-tunnus {BRAND.businessId} · {BRAND.email}
          </p>
          <p>{BRAND.tagline}</p>
        </div>
      </div>
    </footer>
  );
}
